<template>
<div class="barchart">
    <!-- {{ dataset }} -->
    <div class="legend">
        <div v-for="(d, index) in dataset" :key="index"> {{ dateFormat(d.month) }}</div>
    </div>
    <div class="bars">
        <div v-for="(d, index) in dataset" :key="index" class="bar" :style="{height: scale(d.value) + '%'}" :title="d.value"></div>
    </div>
</div>
</template>

<script>
import * as d3_array from 'd3-array';

export default {
    props: ['dataset'],

    computed: {
        domain() {
            return [0, d3_array.max(this.dataset, d => d.value)];
        },

        range() {
            return [0, 100]
        },

        scale() {
            return v => v / this.domain[1] * this.range[1];
        },
    },

    methods: {
        dateFormat(d){
            return d.split('-')[1];
        }
    }

}

</script>

<style lang="scss" scoped>
.barchart {
    width: 100;

    .bars, .legend {
        width: 100%;
        display: flex;
        gap: 0.2em;

        div {
            width: 1rem;
            display: block;
            text-align: center;
            // letter-spacing: -0.1em;
        }
    }

    .bars {
        // border: 1px solid black;
        height: 2em;
        align-items: flex-end;

        .bar {
            // width: 1em;
            background-color: var(--col-main-grey);

        }
    }

    .legend {
        div {
            font-size: 0.6em;
            font-weight: 600;
        }
    }
}
</style>